import React from "react";
import { Box, Popover, MenuItem } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useSelector } from "react-redux";

const LanguagePopover = ({
  langIcon,
  languageData = [],
  selectedLanguage,
  onChange,
  theme,
}) => {

  const {
    css
  }=useSelector((store)=> store?.widgetSettings);
  const overAll = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Overall"
  )?.fields
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpen = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (langCode) => {
    onChange(langCode);
    handleClose();
  };

  const open = Boolean(anchorEl);

  return (
    <>
      {/* Trigger Button */}
      <Box
        onClick={handleOpen}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: overAll?.langBgColor,
          borderRadius: "8px",
          padding: "8px 12px",
          cursor: "pointer",
          width: "150px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          "&:hover": {
            backgroundColor: overAll?.MainLanguageBackgroundColorHover,
          },
        }}
      >
        <img
          src={langIcon}
          alt="language"
          style={{
            width: 40,
            height: 40,
            objectFit: "contain",
          }}
          loading="lazy"
        />
        <KeyboardArrowDownIcon
          sx={{
            color: "#666",
            fontSize: 20,
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        />
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: "8px",
            minWidth: 150,
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
        }}
        disableEnforceFocus
        disableAutoFocus
        disableRestoreFocus
        disableScrollLock
      >
        <Box>
          {languageData.map((item) => {
            const isSelected =
              item?.langcode?.trim() === selectedLanguage?.trim();
            return (
              <MenuItem
                key={item?.idlanguage}
                onClick={() => handleSelect(item?.langcode)}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  color:overAll?.
                  langMenuTextClr,
                  fontSize: "14px",
                  padding: "10px 16px",
                  backgroundColor:isSelected ? overAll?.langMenuSelectBgClr :overAll?.langMenuItemBgClr,
                }}
              >
                {item?.language}

                {isSelected && (
                  <CheckBoxIcon
                    sx={{
                      color: overAll?.langCheckboxActive
                      ,
                      ml: 1,
                      fontSize: 20,
                    }}
                  />
                )}
              </MenuItem>
            );
          })}
        </Box>
      </Popover>
    </>
  );
};

export default LanguagePopover;
